/**
 * Composition manager context for Steve Render Service.
 *
 * Tracks registered assets (audio/video) and sequences during rendering.
 * The renderer reads `window.picmaker_collectAssets()` to gather audio
 * tracks for the final encode.
 *
 * Written from scratch for Steve.AI.
 */

import { createContext } from 'react';

export const CompositionManager = createContext({
  compositions: [],
  registerComposition: () => undefined,
  unregisterComposition: () => undefined,
  registerFolder: () => undefined,
  unregisterFolder: () => undefined,
  currentComposition: null,
  setCurrentComposition: () => undefined,
  setCurrentCompositionMetadata: () => undefined,
  registerSequence: () => undefined,
  unregisterSequence: () => undefined,
  registerAsset: () => undefined,
  unregisterAsset: () => undefined,
  sequences: [],
  assets: [],
  folders: [],
  currentCompositionMetadata: null,
});
